module.exports = __webpack_public_path__ + "img/rating.7e6b3e39.svg";